module.exports = __webpack_public_path__ + "media/images/icon_list/message_filled-dbfdde16dc0ea0cafcb209d3bfce388d.svg";